module.exports = __webpack_public_path__ + "img/placket_width.d4eb1524.png";